import { logoStyles } from "@insite/content-library/Widgets/Basic/Logo";
import { columnsStyles } from "@insite/content-library/Widgets/ProductList/ProductListColumns";
import { productCountStyles } from "@insite/content-library/Widgets/ProductList/ProductListProductCount";
import { sortSelectStyles } from "@insite/content-library/Widgets/ProductList/ProductListSortSelect";
import { GridOffset } from "@insite/mobius/GridContainer";
import { css } from "styled-components";

Object.assign(sortSelectStyles, {
    ...sortSelectStyles,
    select: {
        labelProps: {
            size: 12,
            fontFamily: "OpenSansItalic",
            css: css`
                width: unset;
                padding-right: 4px;
            `,
        },
        cssOverrides: {
            formField: css`
                width: auto;
                margin-right: 25px;
                select,
                [class^="FormInputWrapper"] {
                    width: auto;
                    max-width: 175px;
                    min-width: 53px;
                    height: 30px !important;
                    font-size: 12px !important;
                    appearance: none;

                    [class^="IconWrapper"] {
                        top: 0px;
                        width: 28px;
                        height: 28px;
                        background-image: url(data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHZlcnNpb249IjEuMSIgeD0iMTJweCIgeT0iMHB4IiB3aWR0aD0iMjRweCIgaGVpZ2h0PSIzcHgiIHZpZXdCb3g9IjAgMCA2IDMiIGVuYWJsZS1iYWNrZ3JvdW5kPSJuZXcgMCAwIDYgMyIgeG1sOnNwYWNlPSJwcmVzZXJ2ZSI+PHBvbHlnb24gcG9pbnRzPSI1Ljk5MiwwIDIuOTkyLDMgLTAuMDA4LDAgIi8+PC9zdmc+);
                        background-repeat: no-repeat;
                        background-position: center center;
                        svg {
                            display: none;
                        }
                    }
                }
            `,
        },
    },
});
